import angular from 'angular'

angular.module('nominas.fondoreserva')
  .service('NominasFondoReservaNominas', NominasFondoReservaNominas);

function NominasFondoReservaNominas($http) {
  this.get = _get;

  function _get(idProyecto) {
    return $http.get('api/nominas/fondo-reserva/nominas', {
      params: {
        id_proyecto: idProyecto,
      },
    });
  }
}



// WEBPACK FOOTER //
// ./src/nominas/fondoreserva/services/FondoReserva/Nominas.js